import {
  SET_PACKAGES,
  CLEAR_SERVICES,
  CLEAR_PACKAGES,
  SET_EXACT_MILEAGE_FLAG
} from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.packages, { type, payload }) {
  switch (type) {
    case SET_PACKAGES:
      return { ...payload, useExactMileageFlag: state.useExactMileageFlag };
    case SET_EXACT_MILEAGE_FLAG:
      return { ...state, useExactMileageFlag: payload };
    case CLEAR_SERVICES:
    case CLEAR_PACKAGES:
      return {
        ...initialState.packages,
        useExactMileageFlag: state.useExactMileageFlag
      };
    case RESET_APP_STATE:
      return initialState.packages;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/packages/reducer.js